import React, { useMemo } from 'react';
import PropertyShow from './property_show';
import configureStore from 'bundles/connect/components/store/configure';
import type { Profile } from 'bundles/connect/types';
import { Provider } from 'react-redux';

type Props = {
  insightsPropertyId: string;
  profile: Profile;
}

export default function PropertyShowTurboContainer({ insightsPropertyId, profile }: Props) {
  const store = useMemo(() => configureStore(
    {
      offMarketProperty: {
        owners: null,
        propertyId: insightsPropertyId
      },
      ui: {
        profile
      }
    }
  ), []);

  return (
    <Provider store={store}>
      <PropertyShow
        fromConsole={false}
        fromTurbo={true}
        fullscreen={false}
        hasProfile={!!profile}
        inRethink={false}
        insightsPropertyId={insightsPropertyId}
      />
    </Provider>
  );
}
